import React from 'react';

const PROGRESS_DOT_COUNT = 8;
const CODE_LINE_COUNT = 12;

/**
 * Placeholder chrome shown while StudyLogic loads deck + cards.
 * Mirrors StudyShell layout so the transition into study feels continuous.
 */
export default function StudyLoadingSkeleton() {
  return (
    <div
      className="study-viewer study-viewer--cookbook"
      aria-busy="true"
      aria-label="Loading study content"
    >
      <div className="study-viewer__layout">
        <div className="study-viewer-skeleton study-shell">
          <div className="study-viewer-skeleton__navbar study-shell__navbar">
            <span
              className="study-viewer-skeleton__block study-viewer-skeleton__icon"
              aria-hidden
            />
            <span
              className="study-viewer-skeleton__block study-viewer-skeleton__crumb"
              aria-hidden
            />
            <span
              className="study-viewer-skeleton__block study-viewer-skeleton__title"
              aria-hidden
            />
            <div className="study-shell__navbar-right">
              <span
                className="study-viewer-skeleton__block study-viewer-skeleton__pill"
                aria-hidden
              />
              <span
                className="study-viewer-skeleton__block study-viewer-skeleton__pill"
                aria-hidden
              />
            </div>
          </div>

          <div className="study-viewer-skeleton__card-header study-card__header">
            <div className="study-viewer-skeleton__card-header-actions" aria-hidden>
              <span className="study-viewer-skeleton__block study-viewer-skeleton__nav-btn" />
              <span className="study-viewer-skeleton__block study-viewer-skeleton__nav-btn" />
              <span className="study-viewer-skeleton__block study-viewer-skeleton__nav-btn" />
            </div>
            <div className="study-viewer-skeleton__card-header-meta" aria-hidden>
              <span className="study-viewer-skeleton__block study-viewer-skeleton__line study-viewer-skeleton__line--wide" />
              <span className="study-viewer-skeleton__block study-viewer-skeleton__line study-viewer-skeleton__line--medium" />
            </div>
          </div>

          <div className="study-viewer-skeleton__progress study-shell__progress-strip">
            <div className="study-shell__progress-nav">
              <div className="study-shell__progress-nav-buttons">
                <span
                  className="study-viewer-skeleton__block study-viewer-skeleton__nav-btn"
                  aria-hidden
                />
                <span
                  className="study-viewer-skeleton__block study-viewer-skeleton__nav-btn"
                  aria-hidden
                />
              </div>
              <div className="study-viewer-skeleton__dots" aria-hidden>
                {Array.from({ length: PROGRESS_DOT_COUNT }, (_, index) => (
                  <span
                    key={`study-viewer-skeleton-dot-${index}`}
                    className="study-viewer-skeleton__block study-viewer-skeleton__dot"
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="study-shell__body">
            <div className="study-viewer-skeleton__editor" aria-hidden>
              {Array.from({ length: CODE_LINE_COUNT }, (_, index) => (
                <span
                  key={`study-viewer-skeleton-code-line-${index}`}
                  className={[
                    'study-viewer-skeleton__block',
                    'study-viewer-skeleton__code-line',
                    index % 4 === 3 ? 'study-viewer-skeleton__code-line--short' : '',
                    index % 5 === 0 ? 'study-viewer-skeleton__code-line--indent' : ''
                  ]
                    .filter(Boolean)
                    .join(' ')}
                />
              ))}
            </div>
          </div>

          <div className="study-viewer-skeleton__footer study-shell__footer">
            <span
              className="study-viewer-skeleton__block study-viewer-skeleton__footer-btn"
              aria-hidden
            />
            <span
              className="study-viewer-skeleton__block study-viewer-skeleton__footer-btn study-viewer-skeleton__footer-btn--primary"
              aria-hidden
            />
          </div>
        </div>
      </div>
    </div>
  );
}
